import { render, staticRenderFns } from "./revisionBackground.vue?vue&type=template&id=2ff6990a&scoped=true&"
import script from "./revisionBackground.vue?vue&type=script&lang=js&"
export * from "./revisionBackground.vue?vue&type=script&lang=js&"
import style0 from "./revisionBackground.vue?vue&type=style&index=0&id=2ff6990a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff6990a",
  null
  
)

export default component.exports